import React, { useEffect, useState } from "react"
import Layout from "../../../../../components/Layout"
import Breadcrumb from "../../../../../components/Breadcrumb"
import Booklet from "../../../../../components/Booklet"
import { useAxiosClient } from "../../../../../Services/UseAxiosClient"
import htmlParse from "html-react-parser"
import defaultImage from "../../../../../images/news-logo.jpg"
import { Fragment } from "react"

export default function Economist({ pageContext = {}, params = {} }) {
  const id = pageContext.id || params.id;
  const ctypk = pageContext.ctypk || params.ctypk;
  const [commercialDiscount, setCommerticalDiscount] = useState({})
  const [category, setCategory] = useState({})

  const path = [
    { label: "Inicio", to: "/" },
    {
      label: "Descuentos comerciales",
      to: "/descuentos-comerciales",
    },
    ctypk && {
      label: category.title,
      to: `/descuentos-comerciales/${ctypk}/${category.slug}`,
    },
    {
      label: commercialDiscount?.title,
    },
  ]

  const [{ data: listCategories }] = useAxiosClient({
    url: `/agreements/categories/intranet/`,
    method: "GET",
  })

  useEffect(() => {
    if (listCategories && listCategories?.length && ctypk) {
      setCategory(listCategories.find(i => i.pk === +ctypk))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listCategories])

  // get commercial discount
  const [{ data: commercialDiscountData }] = useAxiosClient({
    url: `/agreements/${id}/intranet/`,
    method: "GET",
  })

  useEffect(() => {
    if (commercialDiscountData) {
      setCommerticalDiscount(commercialDiscountData)
    }
  }, [commercialDiscountData])

  const renderSecionFiles = () => {
    if (!commercialDiscount?.file) return <Fragment />

    return (
      <Booklet
        title="Información:"
        icon="far fa-file"
        link={commercialDiscount.file}
        text="ver acuerdo"
        blank
      />
    )
  }

  return (
    <Layout>
      <Breadcrumb path={path} />
      <div className="Medium">
        <span className="Medium-date">
          {commercialDiscount?.publication_date}
        </span>
        <span className="Medium-title">{commercialDiscount?.title}</span>
        <div className="Medium-info">
          <div className="Medium-wrapper">
            {htmlParse(commercialDiscount?.description || `undefined`)}
            {renderSecionFiles()}
          </div>
          <a
            href={commercialDiscount?.link_banner}
            className="Medium-link-banner"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="Economist-image"
              src={commercialDiscount?.image || defaultImage}
              alt="Medio"
            />
          </a>
        </div>
      </div>
    </Layout>
  )
}
